import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-signup-step-one',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div [formGroup]="formGroup">
      <div class="form-group mb-3">
        <label for="fullName" class="form-label">Full Name</label>
        <input 
          type="text" 
          class="form-control" 
          id="fullName" 
          formControlName="fullName"
          placeholder="Enter your full name"
          [class.is-invalid]="formGroup.get('fullName')?.invalid && formGroup.get('fullName')?.touched"
        />
        <div class="invalid-feedback" *ngIf="formGroup.get('fullName')?.invalid && formGroup.get('fullName')?.touched">
          <span *ngIf="formGroup.get('fullName')?.errors?.['required']">Full name is required</span>
          <span *ngIf="formGroup.get('fullName')?.errors?.['minlength']">Full name must be at least 2 characters</span>
        </div>
      </div>

      <div class="form-group mb-3">
        <label for="email" class="form-label">Email Address</label>
        <input 
          type="email" 
          class="form-control" 
          id="email" 
          formControlName="email"
          placeholder="Enter your email address"
          [class.is-invalid]="formGroup.get('email')?.invalid && formGroup.get('email')?.touched"
        />
        <div class="invalid-feedback" *ngIf="formGroup.get('email')?.invalid && formGroup.get('email')?.touched">
          <span *ngIf="formGroup.get('email')?.errors?.['required']">Email is required</span>
          <span *ngIf="formGroup.get('email')?.errors?.['email']">Please enter a valid email</span>
        </div>
      </div>

      <div class="form-group mb-4">
        <label for="phone" class="form-label">Phone Number</label>
        <input 
          type="tel" 
          class="form-control" 
          id="phone" 
          formControlName="phone"
          placeholder="Enter your phone number"
          [class.is-invalid]="formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched"
        />
        <div class="invalid-feedback" *ngIf="formGroup.get('phone')?.invalid && formGroup.get('phone')?.touched">
          <span *ngIf="formGroup.get('phone')?.errors?.['required']">Phone number is required</span>
          <span *ngIf="formGroup.get('phone')?.errors?.['pattern']">Please enter a valid phone number</span>
        </div>
      </div>

      <button 
        type="button" 
        class="btn btn-primary w-100"
        (click)="onNext()"
        [disabled]="!isStepValid()"
      >
        Next
      </button>
    </div>
  `,
  styles: [`
    .form-control {
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      font-size: 14px;
    }

    .form-control:focus {
      border-color: #6a49f2;
      box-shadow: 0 0 0 0.2rem rgba(106, 73, 242, 0.15);
    }

    .form-label {
      font-weight: 500;
      margin-bottom: 8px;
      color: #3e3f66;
    }

    .btn-primary {
      background: #6a49f2;
      border: none;
      padding: 12px;
      border-radius: 8px;
      font-weight: 600;
      transition: all 0.3s;
    }

    .btn-primary:hover:not(:disabled) {
      background: #5639d9;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(106, 73, 242, 0.3);
    }

    .btn-primary:disabled {
      background: #ccc;
      cursor: not-allowed;
    }

    .is-invalid {
      border-color: #dc3545;
    }

    .invalid-feedback {
      display: block;
      color: #dc3545;
      font-size: 12px;
      margin-top: 4px;
    }
  `]
})
export class SignupStepOneComponent {
  @Input() formGroup!: FormGroup;
  @Output() nextStep = new EventEmitter<void>();

  isStepValid(): boolean {
    const fullName = this.formGroup.get('fullName');
    const email = this.formGroup.get('email');
    const phone = this.formGroup.get('phone');
    return !!(fullName?.valid && email?.valid && phone?.valid);
  }

  onNext(): void {
    if (this.isStepValid()) {
      this.nextStep.emit();
    }
  }
}
